import { motion } from "framer-motion";
import { Loader2, AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

export function ShopMissing({ slug }) {
  return (
    <div className="min-h-screen bg-void text-white flex items-center justify-center p-6">
      <div className="glass-strong rounded-2xl p-10 max-w-lg text-center">
        <div className="font-numbers text-xs tracking-[0.3em] text-gold uppercase mb-3">
          Shop Not Found
        </div>
        <h1 className="font-heading text-3xl mb-3">
          No shop with the slug "{slug}"
        </h1>
        <p className="text-white/60 mb-6">
          This shop may not exist yet. Make sure the SQL migrations have been
          run in Supabase and that a row exists in <code className="font-numbers text-gold">shops</code> with this slug.
        </p>
        <Link to="/diagnostics" className="btn-ghost inline-block text-sm">
          Run diagnostics
        </Link>
      </div>
    </div>
  );
}

export function FullPageLoader({ label = "Loading" }) {
  return (
    <div className="min-h-screen bg-void text-white flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="flex flex-col items-center gap-4"
      >
        <Loader2 className="w-8 h-8 text-gold animate-spin" strokeWidth={1.5} />
        <div className="font-numbers text-xs tracking-[0.3em] uppercase text-white/50">
          {label}
        </div>
        <Link
          to="/diagnostics"
          className="font-numbers text-[10px] tracking-[0.25em] uppercase text-white/30 hover:text-gold mt-2"
        >
          Stuck? Run diagnostics →
        </Link>
      </motion.div>
    </div>
  );
}

export function LoadError({ error, onRetry }) {
  return (
    <div className="min-h-screen bg-void text-white flex items-center justify-center p-6">
      <div
        className="glass-strong rounded-2xl p-10 max-w-lg text-center"
        data-testid="load-error"
      >
        <div className="w-12 h-12 mx-auto rounded-full border border-red-400/40 bg-void flex items-center justify-center">
          <AlertTriangle className="w-5 h-5 text-red-400" strokeWidth={1.5} />
        </div>
        <div className="font-numbers text-xs tracking-[0.3em] text-red-400 uppercase mt-5">
          Connection Failed
        </div>
        <h1 className="font-heading text-2xl mt-2">Could not reach Supabase</h1>
        <p className="text-white/60 text-sm mt-4 break-words">
          {error?.message || "Unknown error"}
        </p>
        <div className="mt-7 flex items-center justify-center gap-3">
          {onRetry && (
            <button onClick={onRetry} className="btn-gold text-sm py-2 px-4" data-testid="retry-btn">
              Try Again
            </button>
          )}
          <Link to="/diagnostics" className="btn-ghost text-sm" data-testid="open-diagnostics">
            Run Diagnostics
          </Link>
        </div>
      </div>
    </div>
  );
}
